import { useEffect } from "react";
import { useAdminSocketEvent } from "@/lib/adminSocket";
import { useAdminReviewQueueStore } from "@/stores/adminReviewQueueStore";

/**
 * Mounted once by the admin layout: loads the queue summary (dashboard card and
 * nav badge) and refetches it whenever the server says the queue changed.
 */
export function useAdminReviewQueueSync(): void {
  const refreshSummary = useAdminReviewQueueStore((s) => s.refreshSummary);
  useEffect(() => {
    void refreshSummary();
  }, [refreshSummary]);
  useAdminSocketEvent("review_queue:changed", () => void refreshSummary());
}
